import { Injectable } from '@angular/core';

import { AnyCustomPropertyValue } from '@reach/interfaces/custom-property/custom-property-value.interface';
import { NodeCreationEdgeInterface } from '@reach/interfaces/edges/edges.types';
import {
	NodeCreationSource,
	NodeCreationSourceBody,
} from '@reach/interfaces/nodes/node-creation-source.interface';
import { NodeInterface } from '@reach/interfaces/nodes/nodes.types';
import { TagCreateBody, TagUpdateBody } from '@reach/interfaces/tags/tag.requests';
import {
	CreateTagResponse,
	DisambiguateTagsResponse,
	UpdateTagResponse,
} from '@reach/interfaces/tags/tag.responses';

import { BaseApiService } from '~app-client/api/_internal';
import { ReachNodeId } from '~app-client/core/types';
import { WorkspaceId } from '~app-client/workspaces/types';
import { isPersistedWorkspaceId } from '~app-client/workspaces/utils';

@Injectable({ providedIn: 'root' })
export class TagsApiService extends BaseApiService {
	protected commonPath = [];

	public async checkExistence(name: string): Promise<DisambiguateTagsResponse> {
		const query = { name };

		return await this.http.get<DisambiguateTagsResponse>(
			this.url('tags', 'disambiguation'),
			query
		);
	}

	public async create(
		workspaceIds: WorkspaceId[],
		name: string,
		source: NodeCreationSource,
		outgoingEdges: NodeCreationEdgeInterface[] = []
	): Promise<CreateTagResponse> {
		const tag: TagCreateBody = { name };
		const sourceBody: NodeCreationSourceBody = { source };
		return await this.http.post<CreateTagResponse>(this.url('tags'), {
			...tag,
			...sourceBody,
			workspaceIds: workspaceIds.filter((id) => isPersistedWorkspaceId(id)),
			outgoingEdges,
		});
	}

	public async updateCustomProperties(
		tagId: ReachNodeId,
		customProperties: AnyCustomPropertyValue[],
		workspaceId: number
	): Promise<AnyCustomPropertyValue[]> {
		const body = {
			customProperties,
			fatherWorkspaceId: workspaceId,
		};
		return await this.http
			.patch<NodeInterface>(this.url('tags', tagId), body)
			.then((node) => node?.customProperties || []);
	}

	public async edit(tagId: ReachNodeId, data: TagUpdateBody): Promise<UpdateTagResponse> {
		const body = data;
		return await this.http.patch<UpdateTagResponse>(this.url('tags', tagId), body);
	}
}
